import React from "react";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { useSelector } from "react-redux";

const Documents = ({
  onClickNext,
  onClickPrevious,
  onClickCancel,
  clientDetails,
}) => {
  const reduxData = useSelector((state) => state.addService);

  return (
    <div>
      <h1>Documents</h1>
      <div
        style={{
          display: "flex",
          marginTop: "20px",
        }}
      >
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickNext}
          />
        </div>
      </div>
    </div>
  );
};

export default Documents;
